import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ========== DISABLE CONSOLE IN PRODUCTION ==========
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for critical issues
}

// Suppress WebSocket connection errors in console
const originalError = console.error;
console.error = (...args: any[]) => {
  // Filter out WebSocket connection errors
  const errorMessage = args[0]?.toString() || '';
  if (
    errorMessage.includes('WebSocket connection to') ||
    errorMessage.includes('ERR_CONNECTION_REFUSED') ||
    errorMessage.includes('net::ERR_CONNECTION_REFUSED') ||
    errorMessage.includes('WebSocket is closed before the connection is established')
  ) {
    // Suppress these errors - they're expected when server is not running
    return;
  }
  // Log other errors normally
  originalError.apply(console, args);
};

// Global error handlers to catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Suppress browser extension errors and network errors
  const errorMessage = event.reason?.message || String(event.reason || '');
  if (
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('ERR_CONNECTION_REFUSED') ||
    errorMessage.includes('Network Error') ||
    errorMessage.includes('ECONNREFUSED')
  ) {
    event.preventDefault();
    return;
  }
  
  // Log other unhandled rejections for debugging
  console.error('Unhandled promise rejection:', event.reason);
});

// Global error handler
window.addEventListener('error', (event) => {
  // Suppress browser extension errors and WebSocket errors
  const errorMessage = event.message || '';
  if (
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('WebSocket connection to') ||
    errorMessage.includes('ERR_CONNECTION_REFUSED') ||
    errorMessage.includes('net::ERR_CONNECTION_REFUSED')
  ) {
    event.preventDefault();
    return;
  }
  
  console.error('Global error:', event.error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);